import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ModalXoa } from "./ChucNang/ModalXoa";
import { ModalKhoaOrMo } from "./ChucNang/ModalKhoaOrMo";
import { ModalLienKetNganHangMB } from "./ChucNang/ModalLienKetNganHangMB";
import { ModalHuyLienKetNganHangMB } from "./ChucNang/ModalHuyLienKetNganHangMB";
import { ThemMoi } from "./ThemMoi";
import { PopoversBootrap } from "../../../components/GenericComponent/PopoversBootrap";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import { BtnLichSu } from "./ChucNang/BtnLichSu";
import { ThongTinChiTiet } from "./ChiTiet/ThongTinChiTiet";

export const ContentTable = ({ dataDanhSach, onSearch }) => {
  const setModalEdit = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };
  const [dataTaiKhoan, setDataTaiKhoan] = useState([]);
  useEffect(() => {
    if (typeof dataDanhSach.List != "undefined") {
      setDataTaiKhoan(dataDanhSach.List);
    }
  }, [dataDanhSach]);

  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanIcloud);
  const ShowConfirmDelete = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const [dataFocus, setDataFocus] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  const [isModalXoa, setModalXoa] = useState(false);
  const toggleModalXoa = () => {
    setModalXoa(!isModalXoa);
  };
  const deleteTaiKhoan = (item) => {
    setDataFocus(item);
    toggleModalXoa();
  };
  const [isModalKhoaOrMo, setModalKhoaOrMo] = useState(false);
  const [isLock, setIsLock] = useState(false);
  const toggleModalKhoaOrMo = () => {
    setModalKhoaOrMo(!isModalKhoaOrMo);
  };
  const khoaOrMoTaiKhoan = (item, isLock) => {
    setDataFocus(item);
    setIsLock(isLock);
    toggleModalKhoaOrMo();
  };
  //Phần show chi tiet
  const showChiTiet = (item) => {
    setDataFocus(item);
    toggleModalChiTiet();
  };
  const [isModalChiTiet, setModalChiTiet] = useState(false);
  const toggleModalChiTiet = () => {
    setModalChiTiet(!isModalChiTiet);
  };
  // end lien kết ngân hàng
  const [isAnMatKhau, setIsAnMatKhau] = useState(1);
  const AnMatKhau = (item) => {
    let danhsachNew = dataTaiKhoan.map(function (elem) {
      if (elem.Id === item.Id) {
        elem.isAnMatKhau = true;
      }
      return elem;
    });
    setDataTaiKhoan(danhsachNew);
  };
  const HienMatKhau = (item) => {
    let danhsachNew = dataTaiKhoan.map(function (elem) {
      if (elem.Id === item.Id) {
        elem.isAnMatKhau = false;
      }
      return elem;
    });
    setDataTaiKhoan(danhsachNew);
  };

  return dataTaiKhoan.map((item, index) => (
    <div
      className="custom-table-row"
      key={item.Id}
      style={item.IsHanChe == true ? { backgroundColor: "#f2aeae" } : {}}
    >
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center">
            {(dataSearch.iPageIndex - 1) * dataSearch.iPageSize + index + 1}
          </p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Tên tài khoản</span>
        <div className="text-left">
          <a
            href={() => false}
            onClick={(e) => showChiTiet(item)}
            style={{ marginRight: "5px" }}
          >
            <p className="text-center">{item.TenTaiKhoan}</p>
          </a>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Mật khẩu</span>
        <div className="center-wrapper">
          <p className="text-center">{item.MatKhau}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Số điện thoại</span>
        <div className="center-wrapper">
          {" "}
          <p className="text-center">{item.SoDienThoai}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Số HD liên kết</span>
        <div className="center-wrapper">
          <p className="text-center">{item.SoHDLienKet}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-20-sm  action-cell">
        <span className="mobile-column-name">Trạng thái</span>
        <div className="center-wrapper">
          {item.IsHanChe == true && <p className="text-center">Hạn chế</p>}
          {item.IsHanChe != true && <p className="text-center">Bình thường</p>}
        </div>
      </div>
      <div className="custom-table-cell flex-basis-15 flex-basis-11-4-sm ">
        <span className="mobile-column-name">Thao Tac</span>
        <div
          className="center-wrapper left-center"
          style={{ fontSize: "20px" }}
        >
          <a
            href={() => false}
            onClick={(e) => setModalEdit(item)}
            style={{ marginRight: "5px" }}
          >
            <PopoversBootrap
              contentText="Sửa"
              titleText=""
              trigger={["hover", "focus"]}
              placement={"top"}
            >
            <img
                  style={{ marginLeft: "5px" }}
                  src="/app-assets/images/icon-edit-v2.png"
                />
            </PopoversBootrap>
          </a>
          {/* <BtnLichSu item={item}></BtnLichSu> */}

          {(item.IsLock == 0 || item.IsLock == null) && (
            <a
              href={() => false}
              onClick={(e) => khoaOrMoTaiKhoan(item, true)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Khóa"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <img
                  style={{ marginLeft: "5px" }}
                  src="/app-assets/images/icon-khoa-cau-hinh-tai-san.png"
                />
              </PopoversBootrap>
            </a>
          )}
          {item.IsLock == 1 && (
            <a
              href={() => false}
              onClick={(e) => khoaOrMoTaiKhoan(item, false)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Mở khóa"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <img
                  style={{ marginLeft: "5px" }}
                  src="/app-assets/images/icon-mo-cau-hinh-tai-san.png"
                />
              </PopoversBootrap>
            </a>
          )}
          {item.SoHDLienKet == 0 && (
            <a
              href={() => false}
              onClick={(e) => deleteTaiKhoan(item)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Xóa"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
              <img
                  style={{ marginLeft: "5px" }}
                  src="/app-assets/images/icon-button-xoa-v2.png"
                />
              </PopoversBootrap>
            </a>
          )}
          {/* {item.isAnMatKhau != false && (
            <a
              href={() => false}
              onClick={(e) => HienMatKhau(item)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Hiện"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <i className="mdi mdi-eye"></i>
              </PopoversBootrap>
            </a>
          )}
          {item.isAnMatKhau == false && (
            <a
              href={() => false}
              onClick={(e) => AnMatKhau(item)}
              style={{ marginRight: "5px" }}
            >
              <PopoversBootrap
                contentText="Ẩn"
                titleText=""
                trigger={["hover", "focus"]}
                placement={"top"}
              >
                <i className="mdi mdi-eye-off"></i>
              </PopoversBootrap>
            </a>
          )} */}
        </div>
      </div>
      {showEdit && (
        <ThemMoi data={dataFocus} show={showEdit} onHide={handleCloseEdit} />
      )}
      {isModalChiTiet && (
        <ThongTinChiTiet
          show={isModalChiTiet}
          onHide={toggleModalChiTiet}
          data={dataFocus}
        />
      )}
      <ModalXoa
        isModalVisible={isModalXoa}
        onSearch={onSearch}
        toggleModal={toggleModalXoa}
        item={dataFocus}
      />
      <ModalKhoaOrMo
        isModalVisible={isModalKhoaOrMo}
        onSearch={onSearch}
        toggleModal={toggleModalKhoaOrMo}
        item={dataFocus}
        isLock={isLock}
      />
    </div>
  ));
};
